module.exports = __webpack_public_path__ + "static/painting-6c9c2e365a8a02caf882bd49142d0baa.jpeg";